<template>
  <div class="terms-page">
    <section class="terms-section">
      <div class="container">
        <div class="terms-content">
          <h1>大连义韶科技有限公司使用条款</h1>
          <p class="version-info">版本更新日期：2026 年 9 月 13 日 &nbsp; | &nbsp; 版本生效日期：2026 年 9 月 13 日</p>

          <p>欢迎使用壹勺芯平台（以下简称 "本平台"）。本平台由大连义韶科技有限公司（以下简称 "我们"）运营。以下条款（以下简称 "本条款"）构成您与我们之间具有法律约束力的协议。请您在使用本平台服务前仔细阅读本条款的全部内容。</p>

          <p>通过访问或使用本平台，即表示您已阅读、理解并同意受本条款的约束。若您不同意本条款的任何内容，请立即停止使用本平台服务。我们保留随时修改本条款的权利，修改后的条款一经发布即生效。您有义务定期查阅本条款的更新内容，若您在本条款修改后继续使用本平台服务，视为您接受修改后的条款。</p>

          <h2>一、服务内容</h2>
          <p>本平台汇聚高校、科研院所、企业及各类创新主体的技术成果、技术需求和专家资源，提供产学研成果发布与对接、创业孵化、技术转移、金融服务对接、专家咨询等全方位服务。我们致力于为创新主体提供高效、便捷的技术转移和成果转化服务。</p>
          <p>我们根据实际运营情况，有权适时调整、增减或变更本平台的服务内容、功能模块及服务方式，并通过平台公告等方式提前告知用户。我们对服务的变更不承担任何责任，但将尽合理努力减少对用户的影响。</p>

          <h2>二、用户注册与账户管理</h2>
          <p><strong>1.注册资格：</strong>您确认，在注册使用本平台服务时，您具备完全民事权利能力和民事行为能力，能够独立承担法律责任。若您为未成年人，应在监护人的监护及同意下注册和使用本平台。</p>
          <p><strong>2.账户注册：</strong>您在注册时应提供真实、准确、完整的注册信息，并保证在信息发生变更时及时更新。您应对注册信息的真实性负责，如因信息不实导致的任何损失或法律责任由您自行承担。</p>
          <p><strong>3.账户安全：</strong>您对您的账户名、密码及验证码的安全性负责，不得将账户出借、转让或以任何方式提供给第三方使用。因您未妥善保管账户信息导致的任何损失，由您自行承担。如发现账户存在未经授权使用的情况，您应立即通知我们。</p>
          <p><strong>4.账户注销：</strong>您有权随时申请注销您的账户。我们将在收到申请后 15 个工作日内完成审核处理。账户注销后，我们将按照隐私政策的相关规定处理您的个人信息。</p>

          <h2>三、用户行为规范</h2>
          <p>您在使用本平台服务时，应遵守国家法律法规、社会公德及本条款的各项约定，不得从事以下行为：</p>
          <p><strong>1.</strong> 发布、传播违法信息，包括但不限于涉及国家安全、社会稳定、淫秽色情、暴力恐怖、赌博诈骗等内容；</p>
          <p><strong>2.</strong> 侵犯他人合法权益，包括但不限于知识产权、商业秘密、名誉权、隐私权等；</p>
          <p><strong>3.</strong> 发布虚假、误导性信息，包括但不限于虚假技术成果、虚假技术需求、虚假专家身份等；</p>
          <p><strong>4.</strong> 利用本平台从事非法交易、传销、欺诈等活动；</p>
          <p><strong>5.</strong> 对本平台系统进行反向工程、破解、攻击、植入病毒或进行任何危害平台安全的行为；</p>
          <p><strong>6.</strong> 通过机器人、爬虫等自动化工具大量抓取平台数据；</p>
          <p><strong>7.</strong> 其他违反法律法规或本平台禁止的行为。</p>
          <p>若我们发现您存在上述违规行为，我们有权采取警告、限制功能、暂停服务、永久封禁账户、删除违规信息等措施，并保留向有关部门举报的权利。</p>

          <h2>四、知识产权</h2>
          <p><strong>1.平台知识产权：</strong>本平台自身提供的所有内容，包括但不限于文字、图片、图表、界面设计、数据汇编、软件程序、商标、标识等，其知识产权归我们或相关权利人所有。未经我们书面许可，任何人不得以任何方式复制、传播、展示、修改、翻译或用于其他商业用途。</p>
          <p><strong>2.用户发布内容：</strong>您在本平台发布的技术成果、技术需求、专家信息、文章等内容，其知识产权归您或相关权利人所有。您授予我们非独占的、免费的、全球范围内的使用许可，以便我们能在本平台上展示、推广和对接您的信息。您保证您发布的内容不侵犯任何第三方的知识产权。</p>
          <p><strong>3.侵权处理：</strong>我们尊重知识产权，若您认为本平台上的内容侵犯了您的合法权益，请及时联系我们并提供相关证明材料，我们将在核实后依法采取删除、屏蔽等必要措施。</p>

          <h2>五、对接与交易规则</h2>
          <p><strong>1.信息真实性：</strong>您在本平台发布的信息应真实、准确、完整。因信息不实导致的对接失败、交易纠纷或法律责任由信息发布方承担。</p>
          <p><strong>2.对接流程：</strong>本平台作为产学研对接服务平台，为您提供信息展示、需求匹配、对接撮合等服务。具体的对接方案、合作条款由对接双方自行协商确定。</p>
          <p><strong>3.交易风险：</strong>对接双方在合作过程中应自行审慎评估对方资质和项目风险。我们不对对接双方之间的合作结果承担任何保证责任，但会尽最大努力维护对接秩序和交易安全。</p>
          <p><strong>4.金融服务：</strong>本平台提供的金融服务对接功能仅作为信息撮合服务，具体的金融产品和服务由合作的金融机构提供，相关权利义务以您与金融机构签订的协议为准。</p>

          <h2>六、免责声明</h2>
          <p><strong>1.</strong> 我们致力于保障本平台的稳定运行，但不对因不可抗力、系统维护、网络故障、第三方服务中断等原因导致的服务中断或数据丢失承担责任。</p>
          <p><strong>2.</strong> 我们对用户在本平台发布的信息的真实性、准确性、完整性不作任何明示或暗示的保证，用户应自行对相关信息进行核实。</p>
          <p><strong>3.</strong> 我们不对用户通过本平台与其他用户之间的合作结果承担任何保证或连带责任，合作过程中产生的纠纷由双方自行解决。</p>
          <p><strong>4.</strong> 在法律法规允许的最大范围内，我们不对因使用或无法使用本平台服务所产生的任何间接、附带、特殊或惩罚性损害赔偿承担责任。</p>

          <h2>七、服务中止与终止</h2>
          <p><strong>1.</strong> 我们有权在以下情况下中止或终止向您提供服务，并保留追究法律责任的权利：</p>
          <p class="sub-item">（1）您违反本条款的任何约定；</p>
          <p class="sub-item">（2）您提供虚假注册信息或发布虚假内容；</p>
          <p class="sub-item">（3）您的行为对本平台或其他用户造成损害；</p>
          <p class="sub-item">（4）法律法规或监管部门要求；</p>
          <p class="sub-item">（5）其他我们认为必要的合理情形。</p>
          <p><strong>2.</strong> 我们有权根据平台运营需要，提前三十日通知后，全面终止本平台的运营。终止运营后，我们将按照法律法规和隐私政策的要求处理您的数据。</p>

          <h2>八、法律适用与争议解决</h2>
          <p><strong>1.</strong> 本条款的订立、履行、解释及争议解决均适用中华人民共和国法律。</p>
          <p><strong>2.</strong> 因本条款引起的或与本条款有关的任何争议，双方应首先友好协商解决；协商不成的，任何一方可将争议提交大连仲裁委员会按照其届时有效的仲裁规则进行仲裁。</p>
          <p><strong>3.</strong> 本条款部分条款无效或不可执行的，不影响其他条款的效力。</p>

          <h2>九、其他</h2>
          <p><strong>1.</strong> 本条款构成您与我们之间的完整协议，取代您之前与我们之间就本平台服务达成的任何口头或书面协议。</p>
          <p><strong>2.</strong> 我们未坚持或强制执行本条款中的任何权利或规定，不应视为对该权利或规定的放弃。</p>
          <p><strong>3.</strong> 您不得将本条款项下的任何权利或义务转让给任何第三方。我们有权将本条款项下的权利和义务转让给关联方或业务承继方。</p>
          <p><strong>4.</strong> 如您对本条款有任何疑问，请通过以下方式联系我们：</p>
          <ul class="contact-list">
            <li>客服邮箱：kefu@yishaoxin.com</li>
            <li>联系电话：0411-XXXXXXXX</li>
            <li>联系地址：辽宁省大连市XX区XX路XX号大连义韶科技有限公司</li>
          </ul>
          <p>我们将在收到您的咨询后 15 个工作日内作出答复。</p>
        </div>
      </div>
    </section>

    <!-- 页脚 -->
    <footer class="footer">
      <div class="container">
        <div class="footer-content">
          <div class="footer-section">
            <h3>大连义韶科技有限公司</h3>
            <div class="social-links">
              <a href="#"><i class="fab fa-weixin"></i></a>
              <a href="#"><i class="fab fa-weibo"></i></a>
              <a href="#"><i class="fab fa-qq"></i></a>
              <a href="#"><i class="fab fa-linkedin"></i></a>
            </div>
          </div>
          <div class="footer-section">
            <h4>快速链接</h4>
            <ul>
              <li><router-link to="/achievement">成果中心</router-link></li>
              <li><router-link to="/demand">需求中心</router-link></li>
              <li><router-link to="/expert">专家中心</router-link></li>
              <li><router-link to="/partner">合作伙伴</router-link></li>
            </ul>
          </div>
          <div class="footer-section">
            <h4>联系我们</h4>
            <ul class="contact-info">
              <li><i class="fas fa-map-marker-alt"></i> xxxxxxxxx</li>
              <li><i class="fas fa-phone"></i> xxxxxxxx</li>
              <li><i class="fas fa-envelope"></i> xxxxxxxx</li>
            </ul>
          </div>
        </div>
        <div class="footer-bottom">
          <p>&copy; 2026 大连义韶科技有限公司 版权所有 <span>|</span> <router-link to="/privacy">隐私政策</router-link> <span>|</span> <router-link to="/terms">使用条款</router-link></p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script setup>
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.terms-page {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  line-height: 1.5715;
  color: rgba(0, 0, 0, 0.85);
  background-color: #f0f2f5;
}

.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

a { text-decoration: none; color: inherit; }
ul { list-style: none; }

/* 使用条款内容 */
.terms-section {
  padding: 48px 0;
  background: white;
}

.terms-content {
  max-width: 900px;
  margin: 0 auto;
  padding: 0 20px;
}

.terms-content h1 {
  font-size: 28px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 16px;
}

.version-info {
  text-align: center;
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
  margin-bottom: 24px;
}

.terms-content > p {
  font-size: 15px;
  line-height: 1.8;
  color: rgba(0, 0, 0, 0.65);
  margin-bottom: 16px;
  text-indent: 2em;
}

.terms-content h2 {
  font-size: 20px;
  font-weight: 600;
  margin-top: 32px;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f0f0;
}

.terms-content p strong {
  color: rgba(0, 0, 0, 0.85);
}

.terms-content p.sub-item {
  padding-left: 2em;
  text-indent: 0;
  margin-bottom: 8px;
}

.contact-list {
  list-style: none;
  padding: 12px 20px;
  background: #fafafa;
  border-radius: 6px;
  margin-bottom: 16px;
}

.contact-list li {
  font-size: 15px;
  line-height: 2;
  color: rgba(0, 0, 0, 0.65);
}

/* 页脚 */
.footer {
  background: #fafafa;
  color: rgba(0, 0, 0, 0.85);
  padding: 48px 0 24px;
  border-top: 1px solid #f0f0f0;
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 48px;
  margin-bottom: 40px;
}

.footer-section h3, .footer-section h4 {
  font-weight: 600;
  margin-bottom: 20px;
}

.footer-section p {
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  margin-bottom: 16px;
}

.social-links {
  display: flex;
  gap: 12px;
}

.social-links a {
  width: 32px;
  height: 32px;
  background: #f5f5f5;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(0, 0, 0, 0.65);
  transition: all 0.3s;
}

.social-links a:hover {
  background: #1890ff;
  color: white;
}

.footer-section ul li {
  margin-bottom: 12px;
}

.footer-section ul li a {
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  transition: all 0.3s;
}

.footer-section ul li a:hover { color: #1890ff; }

.footer-bottom {
  text-align: center;
  padding-top: 24px;
  border-top: 1px solid #f0f0f0;
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
}

.footer-bottom a {
  color: rgba(0, 0, 0, 0.45);
  transition: color 0.3s;
}

.footer-bottom a:hover { color: #1890ff; }
.footer-bottom span { margin: 0 16px; }

/* ================= 响应式 ================= */
@media (max-width: 768px) {
  .terms-section { padding: 24px 0; }
  .terms-content { padding: 0 12px; }
  .terms-content h1 { font-size: 22px; }
  .terms-content h2 { font-size: 18px; margin-top: 24px; }
  .terms-content h3 { font-size: 15px; }
  .terms-content > p { font-size: 14px; text-indent: 0; }
  .version-info { font-size: 12px; }
  .container { padding: 0 12px; }
  .footer-bottom { font-size: 12px; }
  .footer-bottom span { margin: 0 8px; }
}

@media (max-width: 480px) {
  .terms-content h1 { font-size: 18px; }
  .terms-content h2 { font-size: 16px; }
  .terms-content { padding: 0 8px; }
}
</style>
